import { Check } from "lucide-react";
import { rateComparison } from "@/data/resort";
import { cn } from "@/lib/utils";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function RateComparison() {
  return (
    <section
      id="compare"
      aria-labelledby="rate-compare-heading"
      className="bg-secondary/50 py-16 md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>Compare Your Options</Eyebrow>
        </Reveal>
        <h2 id="rate-compare-heading" className="display-lg mt-6 max-w-[18ch]">
          <MaskReveal>Which Stay Is Right</MaskReveal>
          <MaskReveal delay={0.08}>for You?</MaskReveal>
        </h2>

        <ul className="mt-10 grid gap-6 lg:grid-cols-3">
          {rateComparison.map((option, i) => (
            <li key={option.id}>
              <Reveal delay={i * 0.07} className="h-full">
                <article
                  className={cn(
                    "flex h-full flex-col border p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-soft md:p-10",
                    option.featured
                      ? "border-primary bg-primary text-primary-foreground"
                      : "border-border bg-background",
                  )}
                >
                  <p className="eyebrow opacity-70">{option.label}</p>
                  <p className="mt-6 text-sm uppercase tracking-[0.18em] opacity-70">Starting at</p>
                  <p className="font-display mt-2 text-5xl tracking-tight md:text-6xl">
                    {option.from}
                  </p>
                  <p className="eyebrow mt-8 opacity-70">Best for</p>
                  <ul className="mt-4 flex-1 space-y-3">
                    {option.bestFor.map((item) => (
                      <li key={item} className="flex items-start gap-3 text-sm leading-relaxed">
                        <Check
                          className={cn(
                            "mt-0.5 size-4 shrink-0",
                            option.featured ? "text-accent" : "text-primary",
                          )}
                          strokeWidth={1.6}
                        />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <ResortLink
                    variant={option.featured ? "gold" : "solid"}
                    href="/reservations/"
                    className="mt-10 w-full"
                  >
                    {option.cta}
                  </ResortLink>
                </article>
              </Reveal>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
